import moment from 'moment';

export const dateSorter = (a, b) => {
    let timeA = moment(a);
    let timeB = moment(b);

    if (timeA.isBefore(timeB)) {
        return -1;
    }
    if (timeB.isBefore(timeA)) {
        return 1;
    }
    return 0;
}


// WEBPACK FOOTER //
// ./src/lib/tableSorters.js